import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  options1: DropdownOption[] = [
    {
      id: 'option11',
      name: 'option11',
      label: 'option 11',
      ariaLabel: 'option11',
      url: '/dropdown'
    },
    {
      id: 'option12',
      name: 'option12',
      label: 'option 12',
      url: '/dropdown'
    },
    {
      id: 'option13',
      name: 'option13',
      label: 'option 13',
      url: '/dropdown'
    }
  ];
  selectedOptions1!: DropdownOption;

  options2: DropdownOption[] = [
    {
      id: 'option21',
      name: 'option21',
      label: 'option 21',
      url: '/dropdown'
    },
    {
      id: 'option22',
      name: 'option22',
      label: 'option 22',
      url: '/dropdown'
    },
    {
      id: 'option23',
      name: 'option23',
      label: 'option 23',
      url: '/dropdown'
    }
  ];
  selectedOptions2!: DropdownOption;

  options3: DropdownOption[] = [
    {
      id: 'option31',
      name: 'option31',
      label: 'option 31',
      url: '/dropdown',
      icon: 'icon-user-circle'
    },
    {
      id: 'option32',
      name: 'option32',
      label: 'option 32',
      url: '/dropdown',
      icon: 'icon-user-circle'
    },
    {
      id: 'option33',
      name: 'option33',
      label: 'option 33',
      url: '/dropdown',
      icon: 'icon-user-circle'
    }
  ];
  selectedOptions3!: DropdownOption;

  options4: DropdownOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 41',
      url: '/dropdown'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 42',
      url: '/dropdown'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 43',
      url: '/dropdown',
      icon: 'icon-user-circle',
      disabled: true
    }
  ];
  selectedOptions4!: DropdownOption;
  buttonData = {
    id: 'label',
    name: 'label',
    label: 'label',
    type: 'button',
    list:[{
      id: 'clearAll',
      name: 'clearAll',
      label: 'Clear',
      hasCloseButton: true,
      url: '/dropdown',
    }],
  }
  options10: DropdownOption[] = [
    {  
      id: 'grammar',
      name: 'grammar',
      label: 'Grammar',
      isTitle: true
    },
    {
      id: 'GrammarPreparation',
      name: 'GrammarPreparation',
      label: 'Grammar Preparation: Present perftect simple and past simple ',
      url: '/dropdown'
    },
    {
      id: 'vocabularyPreparation',
      name: 'vocabularyPreparation',
      label: 'vocabulary Preparation: Collections: making big decisions',
      url: '/dropdown'
    },
    {
      id: 'PronounciationPreparation',
      name: 'PronounciationPreparation',
      label: 'Pronounciation Preparation: s and ve',
      url: '/dropdown'
    },
    {  
      id: 'reading',
      name: 'reading',
      label: 'Reading',
      isTitle: true
    },{
      id: 'GrammarReading',
      name: 'GrammarReading',
      label: 'Grammar Preparation: Present perftect simple and past simple ',
      url: '/dropdown'
    },
    {
      id: 'vocabularyReading',
      name: 'vocabularyReading',
      label: 'vocabulary Preparation: Collections: making big decisions',
      url: '/dropdown'
    },
    {
      id: 'PronounciationReading',
      name: 'PronounciationReading',
      label: 'Pronounciation Preparation: s and ve',
      url: '/dropdown'
    }    
  ];
  selectedOptions10!: any;
  options11: DropdownOption[] = [
    {
      id: '21Lession',
      name: '21Lession',
      label: '2.1 Lession important decisions ',
      url: '/dropdown'
    },
    {
      id: '22Lession',
      name: '22Lession',
      label: '2.2 Lession you can do it!',
      url: '/dropdown'
    },
    {
      id: '23Lession',
      name: '23Lession',
      label: '2.3 Lession Speaking',
      url: '/dropdown'
    }   
  ];
  selectedOptions11!: DropdownOption;
  buttonData1 = {
    id: 'label',
    name: 'label',
    label: 'label',
    type: 'button',
    list:[{
      id: 'clearAll0',
      name: 'clearAll',
      label: 'Clear',
      hasCloseButton: true,
      url: '/dropdown',
    }],
  }

    options12: DropdownOption[] = [
    {
      id: 'option112',
      name: 'option112',
      label: 'Unit 1',
      ariaLabel: 'Unit 1-From day to day Go again',
      subText: 'From day to day',
      url: '/dropdown',
      chipId: 'chipId-index1',
      hasOptionStatus: true,
      hasChipOutline: true,
      hasChipStatusIcon: true,
      chipLable: 'Go again',
      chipStatus: 'success',
      chipAriaLable: 'chip label'
    },
    {
      id: 'option122',
      name: 'option122',
      label: 'Unit 2',
      ariaLabel: 'Unit 2- Colors In progress ',
      subText: 'Colors',
      url: '/dropdown',
      chipId: 'chipId-index2',
      hasOptionStatus: true,
      hasChipOutline: true,
      hasChipStatusIcon: true,
      chipLable: 'In progress',
      chipStatus: 'primary',
      chipAriaLable: 'chip label'
    },
    {
      id: 'option132',
      name: 'option132',
      label: 'Unit 3',
      ariaLabel: 'Unit 3 - Our Society Not started',
      subText: 'Our Society',
      url: '/dropdown',
      chipId: 'chipId-index3',
      hasOptionStatus: true,
      hasChipOutline: true,
      hasChipStatusIcon: true,
      chipLable: 'Not started',
      chipStatus: 'default',
      chipAriaLable: 'chip label'
    },
    {
      id: 'option142',
      name: 'option142',
      label: 'Unit 4',
      ariaLabel: 'Unit 4- On the home Not Available',
      subText: 'On the home',
      url: '/dropdown',
      chipId: 'chipId-index4',
      hasOptionStatus: true,
      hasChipOutline: true,
      hasChipStatusIcon: true,
      chipDisable: true,
      chipLable: 'Not Available',
      chipStatus: 'default',
      chipAriaLable: 'chip label'
    }
  ];
  selectedOptions12!: DropdownOption;
  buttonData2 = {
    id: 'label',
    name: 'label',
    label: 'Switch Profile',
    type: 'button'
  }
  options13: DropdownOption[] = [
    {
      id: 'option112',
      name: 'option112',
      label: 'Unit 1',
      ariaLabel: 'Unit 1-From day to day Go again',
      subText: 'From day to day',
      iconUrl: '../assets/default/images/add-book.svg',
      iconAltText: 'Unit 1',
      url: '/dropdown'
    },
    {
      id: 'option122',
      name: 'option122',
      label: 'Unit 2',
      ariaLabel: 'Unit 2- Colors In progress ',
      subText: 'Colors',
      icon: 'icon-user-circle',
      url: '/dropdown'
    }
  ];
  selectedOptions13!: DropdownOption;
  form!: FormGroup;
  hasSubmitFormData = false as boolean;
  hasSubmitFormData1 = true as boolean;
  submitted = false;
  isBrowser = true;
  label = 'Select';
  label1 = 'label';
  hasCheckboxesDropdown = true;
  private queryParamSubscription!: Subscription;

  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      this.queryParamSubscription = this.route.queryParams.subscribe(param => {
        this.options2.forEach((obj) => {
          if (param[obj.id] && param[obj.id] === obj.id) {
            obj.checked = true;
          } else {
            obj.checked = false;
          }
        });
        this.onChange();
      });
    }
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if(param.selectedDropdownOptionId === 'label'){
        if(param.dropdownId && param.dropdownId === 'dropdownId11'){
          this.selectedOptions10 = this.buttonData;
        }
        if(param.dropdownId && param.dropdownId === 'dropdownId12'){
          this.selectedOptions11 = this.buttonData;
        }
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId1') {
        this.options1.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions1 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId3') {
        this.options3.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions3 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId4') {
        this.options4.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions4 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId11') {
        this.options10.forEach((obj) => {

          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions10 = obj;

          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId12') {
        this.options11.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions11 = obj;
          } else {
            obj.active = false;
          }
        });
      }   
      if (param.dropdownId && param.dropdownId === 'dropdownId13') {
        this.options12.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions12 = obj;
          } else {
            obj.active = false;
          }
        });
      }  
      if (param.dropdownId && param.dropdownId === 'dropdownId14') {
        this.options13.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions13 = obj;
          } else {
            obj.active = false;
          }
        });
      }   
    });
  }

  onChange() {
    let selectedOptionsCount = this.options2.filter((obj) => obj.checked).length;
    if (selectedOptionsCount !== 0) {
      this.label = selectedOptionsCount + ' selected';
    } else {
      this.label = 'Select';
    }
  }

  options5: DropdownOption[] = [
    {
      id: 'option51',
      name: 'option51',
      label: 'option 51',
      value: 'option 51'
    },
    {
      id: 'option52',
      name: 'option52',
      label: 'option 52',
      value: 'option 52'
    },
    {
      id: 'option53',
      name: 'option53',
      label: 'option 53',
      value: 'option 53'
    }
  ];
  selectedOptions5!: DropdownOption;

  options6: DropdownOption[] = [
    {
      id: 'option61',
      name: 'option61',
      label: 'option 61',
      value: 'option 61'
    },
    {
      id: 'option62',
      name: 'option62',
      label: 'option 62',
      value: 'option 62'
    },
    {
      id: 'option63',
      name: 'option63',
      label: 'option 63',
      value: 'option 63'
    }
  ];
  selectedOptions6!: DropdownOption;

  options7: DropdownOption[] = [
    {
      id: 'option71',
      name: 'option71',
      label: 'option 71'     
    },
    {
      id: 'option72',
      name: 'option72',
      label: 'option 72'
    },
    {
      id: 'option73',
      name: 'option73',
      label: 'option 73'
    }
  ];
  selectedOptions7!: DropdownOption;

  options8: DropdownOption[] = [
    {
      id: 'option81',
      name: 'option81',
      label: 'option 81',
      value: 'option 81'
    },
    {
      id: 'option82',
      name: 'option82',
      label: 'option 82',
      value: 'option 82'
    },
    {
      id: 'option83',
      name: 'option83',
      label: 'option 83',
      value: 'option 83'
    }
  ];
  selectedOptions8!: DropdownOption;
  options9: DropdownOption[] = [
    {
      id: 'option91',
      name: 'option91',
      label: 'option 91'
    },
    {
      id: 'option92',
      name: 'option92',
      label: 'option 92'
    },
    {
      id: 'option93',
      name: 'option93',
      label: 'option 93'
    }
  ];
  selectedOptions9!: DropdownOption;
  menuEvent(selectedOption: DropdownOption, value: string) {
    if (value === 'eventValue') {
      this.selectedOptions5 = selectedOption;
      this.options5.forEach((obj) => {
        if (obj.id === selectedOption.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
      });
    } else if (value === 'eventValue8') {
      this.selectedOptions8 = selectedOption;
      this.options8.forEach((obj) => {
        if (obj.id === selectedOption.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
      });
    } else if (value === 'eventValue9') {
      this.selectedOptions9 = selectedOption;
      this.options9.forEach((obj) => {
        if (obj.id === selectedOption.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
      });
    } else {
      this.selectedOptions6 = selectedOption;
      this.options6.forEach((obj) => {
        if (obj.id === selectedOption.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }
}